import React, { useEffect, useState } from 'react';
import { IntlShape, injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { get, isEmpty, isNil } from 'lodash';
import { toast } from 'react-toastify';
import { PAGES } from 'routes';
import {
  makeSelectLinkToBeneficiaryCodes,
  makeSelectNotification,
} from 'containers/AppContainer/selectors';
import {
  makeDecisionFeeNote,
  requestFeeNoteExceptionalCosts,
  requestFeeNotesByClaimNumb,
  requestAllFeeNotes,
  requestCreateFeeNoteManager,
} from 'containers/ManagerFeeNote/actions';
import {
  requestSetStatusClaimSagis,
  requestGetClaimHistoryActions,
  requestGetClaimHistorySagis,
  requestResetHistoryStore,
  requestSetPriorityClaimProvision,
  requestGetPendingTasksClaim,
  requestMakeDecisionsDocumentImaging,
  requestUploadDocumentManager,
} from 'containers/CourtManagerLegalProceedings/actions';
import { makeSelectPendingTasksClaim } from 'containers/CourtManagerLegalProceedings/selectors';
import { requestGetNotificationsInboxes } from 'containers/AppContainer/actions';
import currentUserStorage from 'containers/services/security/current-user-storage';
import { isBlockStatusClaim } from 'containers/CourtManagerLegalProceedings/utils';
import { setCurrentInstanceTab } from 'containers/AppContainer/actions';
import {
  makeSelectClaimHistoryActions,
  makeSelectClaimHistorySagis,
} from 'containers/CourtManagerLegalProceedings/selectors';
import { Listings } from 'containers/AppContainer/typings';
import { CLAIM_STATUS } from 'containers/data-structure';
import { requestGetDocByDocumentumId } from 'containers/common/UploadDocument/actions';
import {
  requestAddVictims,
  requestLockClaim,
  requestUnlockClaim,
  requestCreateStakeHolder,
} from 'containers/CourtManagerLegalProceedings/actions';
import { requestGetRegulations } from 'containers/CourtManagerLegalProceedings/Provision/redux/actions';
import {
  makeRegulations,
  makeSelectSagisClaim,
} from 'containers/CourtManagerLegalProceedings/Provision/redux/selectors';
import { makeSelectListings } from 'containers/AppContainer/selectors';
import { selectedLoader } from 'containers/AppContainer/Loader/selectors';
import {
  requestUpdateFeeNoteAmount,
  requestCreateFeeNote,
  requestUpdateFeeNoteStatus,
  requestUpdateInvoiceFeeNote,
  requestAddInvoiceFeeNote,
  requestUpdateFirmReferenceManager,
} from 'containers/LawyerFeeNote/actions';
import {
  makeSelecClaimRecap,
  makeSelectCorporealLawyers,
  makeSelecOpenedClaim,
} from 'containers/RecapManagerPage/selectors';
import {
  requestClaimRecap,
  requestRejectClaim,
  requestAssigment,
  requestCorporealLawyers,
  requestUpdateVictimInfo,
  requestValidateVictim,
  requestValidateVehicle,
  requestUpdateVehicleInfo,
  requestValidateProvisionIntervenant,
  resetStoreClaim,
  requestAddClaimNumber,
  requestGetFeeNotesByClaimId,
  requestValidateCompletionClaimManager,
} from 'containers/RecapManagerPage/actions';
import {
  makeSelectFeeNotes,
  makeSelectAllFeeNotes,
  makeSelectCountFeeNotes,
} from 'containers/LawyerFeeNote/selectors';
import {
  requestSearchClaims,
  resetSearchClaimsStore,
} from 'containers/IdentificationPage/actions';
import {
  setClaimRecap,
  requestOpenClaim,
  requestOpenMixedClaim,
} from 'containers/RecapManagerPage/actions';
import {
  makeSelectFoundClaims,
  makeSelectSearchClaims,
} from 'containers/IdentificationPage/selectors';
import { requestSagisClaimInfo } from 'containers/CourtManagerLegalProceedings/Provision/redux/actions';
import { KeycloakUser } from 'containers/RecapManagerPage/typings';
import * as featureService from 'features/fflip-helpers';
import { FEATURES } from 'features/features';
import { renderSearchQuery } from 'containers/ExpertAssignedMissionShow/utils';
import { translate } from 'containers/services/translate';
import messages from 'containers/LawyerRecapPage/messages';
import { requestUpdateClaim } from 'containers/PreOpeningPage/actions';
import {
  requestGetReportsPolicy,
  resetUploadDocumentStore,
  setDocumentId,
  uploadDocument,
} from 'containers/UploadDocuments/actions';
import {
  makeSelectDocument,
  makeSelectDocumentId,
} from 'containers/UploadDocuments/selectors';
import { IUploadedDocument } from 'containers/LawyerLegalProceedingsPage/typings';
import {
  requestAddDocumentClaim,
  setLockedClaim,
} from 'containers/LawyerLegalProceedingsPage/actions';
import CoreButton from 'components/Buttons/CoreButton';
import { resolveSagisClaim } from 'helpers/utils';
import routesHelper from 'containers/services/routes-helper';
import { isLockedClaim } from 'containers/CourtManagerLegalProceedings/utils';
import PendingOrRejectedRecapClaim from 'containers/RecapManagerPage/PendingOrRejectedRecapClaim';
import ValidatedRecapClaim from 'containers/RecapManagerPage/ValidatedRecapClaim';
import useDeepCompareEffect from 'use-deep-compare-effect';
import { STATUS_VALIDATED } from 'containers/LawyerFeeNote/constants';
import { isNotRcRisk } from 'services/utils';
import { priorityClaimReason } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { CLAIM_TYPE } from 'containers/IdentificationPage/SearchResults/ClaimWithNotIndexedPV/constants';
import { ClaimRecapType } from 'typings/claimTypes';
export interface RecapManagerPageProps {
  intl: IntlShape;
  listings: Listings;
  storedClaimToPreopen: any;
  claimId: number;
  requestClaimRecap: Function;
  match: { params: { claimId: number } };
  claimRecap: ClaimRecapType;
  policyInfo: { sagis: {} };
  requestSearchClaims: Function;
  resetSearchClaimsStore: Function;
  setClaimRecap: Function;
  requestRejectClaim: Function;
  requestOpenClaim: Function;
  requestAssigment: Function;
  requestCorporealLawyers: Function;
  requestOpenMixedClaim: Function;
  corporealLawyers: KeycloakUser[];
  openedClaim: any;
  requestUpdateVictimInfo?: Function;
  requestCreateVehicle?: Function;
  requestValidateVictim?: Function;
  requestValidateVehicle: Function;
  requestAddVictims?: Function;
  requestUpdateVehicleInfo: Function;
  requestUpdateClaim?: Function;
  resetUploadDocumentStore?: Function;
  uploadDocument?: Function;
  uploadedDocument: IUploadedDocument;
  setDocumentId?: Function;
  documentId: string;
  requestAddDocumentClaim?: Function;
  requestValidateProvisionIntervenant?: Function;
  requestUnlockClaim: Function;
  requestLockClaim: Function;
  setLockedClaim: Function;
  resetStoreClaim: Function;
  foundClaims: any;
  requestAddClaimNumber: Function;
  feeNotes: any;
  loaders: any;
  requestGetFeeNotesByClaimId: Function;
  allFeeNote: any;
  feeNotesCount: any;
  linkToBeneficiaryCodes: any;
  requestAddInvoiceFeeNote: Function;
  makeDecisionFeeNote: Function;
  requestFeeNoteExceptionalCosts: Function;
  requestAllFeeNotes: Function;
  requestUpdateFeeNoteAmount: Function;
  requestUpdateFeeNoteStatus: Function;
  requestUpdateInvoiceFeeNote: Function;
  requestCreateFeeNote: Function;
  requestFeeNotesByClaimNumb: Function;
  requestSagisClaimInfo: Function;
  sagisClaim: any;
  requestSetStatusClaimSagis: Function;
  userActions: any;
  claimHistorySagis: any;
  requestGetClaimHistoryActions: Function;
  requestGetClaimHistorySagis: Function;
  setCurrentInstanceTab: Function;
  requestCreateStakeHolder: Function;
  requestGetRegulations: Function;
  regulations: any;
  requestCreateFeeNoteManager: Function;
  requestResetHistoryStore: Function;
  requestSetPriorityClaimProvision: Function;
  requestGetReportsPolicy: Function;
  requestGetPendingTasksClaim: Function;
  pendingTasksClaim: any;
  requestMakeDecisionsDocumentImaging: Function;
  requestGetNotificationsInboxes: Function;
  requestUploadDocumentManager: Function;
  requestGetDocByDocumentumId: Function;
  requestUpdateFirmReferenceManager: Function;
  imagineNotification: any;
  requestValidateCompletionClaimManager: Function;
}

export const StyledButton = styled(CoreButton)`
  margin-top: 10px;
  margin-bottom: 20px;
  width: 300px;
  height: 40px;
  background: #ffc912;
  &:hover {
    background-color: #ffc912;
  }
`;
export const RecapManagerPage: React.FC<RecapManagerPageProps> = (
  props,
): JSX.Element => {
  const [isFistUpdate, setIsFistUpdate] = useState<boolean>(true);
  const [dataClaimToUpdate, setDataClaimToUpdate] = useState<any>({});
  const [openFeeNoteDialog, setOpenFeeNoteDialog] = React.useState<boolean>(
    false,
  );
  useEffect(() => {
    return () => {
      props.resetSearchClaimsStore();
      props.resetStoreClaim();
      setDataClaimToUpdate({});
      setIsFistUpdate(true);
    };
  }, []);

  useEffect(() => {
    if (featureService.hasFeature(FEATURES.AUTOMATIC_LOCK_CLAIM)) {
      return () => {
        props.requestUnlockClaim(
          {
            claimNumber: get(props.claimRecap, 'claim.claimNumber'),
          },
          () => {
            props.setLockedClaim(null);
          },
        );
      };
    }
  }, []);

  useEffect(() => {
    if (featureService.hasFeature(FEATURES.AUTOMATIC_LOCK_CLAIM)) {
      const handleBeforeUnload = (event: any) => {
        const message = 'vous allez quitter le mode de gestion du sinsitre';
        event.returnValue = message;
        props.requestUnlockClaim({
          claimNumber: get(props.claimRecap, 'claim.claimNumber'),
        });
      };

      window.addEventListener('beforeunload', handleBeforeUnload);

      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
        // Cleanup logic if needed
      };
    }
  }, [props.claimRecap]);

  useDeepCompareEffect(() => {
    if (!isEmpty(get(props.policyInfo, 'sagis', {}))) {
      if (
        !isLockedClaim(props.policyInfo) &&
        featureService.hasFeature(FEATURES.AUTOMATIC_LOCK_CLAIM) &&
        !isNil(get(props.claimRecap, 'claim.claimNumber', null)) &&
        !isBlockStatusClaim(props.policyInfo) &&
        get(props, 'claimRecap.claim.status') === STATUS_VALIDATED
      ) {
        props.requestLockClaim({
          claimNumber: get(props.claimRecap, 'claim.claimNumber'),
        });
        props.setLockedClaim(get(props.claimRecap, 'claim.claimNumber'));
      }
    }
  }, [props.claimRecap, props.policyInfo]);
  useEffect(() => {
    if (
      !isEmpty(get(props.policyInfo, 'sagis', [])) &&
      featureService.hasFeature(FEATURES.PRIORITY_CLAIM) &&
      (isNil(get(props.claimRecap, 'claim.priorityReasonId', null)) ||
        get(props.claimRecap, 'claim.priorityReasonId', null) != 4)
    ) {
      const priorityReason = priorityClaimReason(
        [],
        !isEmpty(get(resolveSagisClaim(props.policyInfo), 'offeredRisks', []))
          ? get(resolveSagisClaim(props.policyInfo), 'offeredRisks', [])
              .map((el: any) => Number(el.riskProvisions))
              .reduce(
                (accumulator: any, currentValue: any) =>
                  accumulator + currentValue,
              )
          : 0,
        props.listings,
      );
      if (priorityReason) {
        props.requestSetPriorityClaimProvision({
          id: Number(get(props, 'match.params.claimId')),
          claimInfo: { priorityReasonId: priorityReason },
          username: currentUserStorage.get().username,
          isTrackingActive: featureService.hasFeature(
            FEATURES.TRACKING_ACTIONS_USER,
          ),
        });
      }
    }
  }, [props.policyInfo]);

  useEffect(() => {
    if (
      !isEmpty(props.policyInfo) &&
      !get(props.claimRecap, 'claim.claimNumber')
    ) {
      const corporelClaims = get(props.policyInfo, 'sagis.claims', []).filter(
        (c: any) =>
          get(c, 'code') &&
          (!isNotRcRisk(props.listings, c?.code) ||
            (!isNotRcRisk(props.listings, c?.code) &&
              c?.claimType != CLAIM_TYPE.CORPOREL)),
      );
      const foundClaimSagis = corporelClaims.find((c: any) => get(c, 'code'));
      if (foundClaimSagis) {
        props.requestAddClaimNumber({
          id: get(props, 'match.params.claimId'),
          claimNumber: get(foundClaimSagis, 'code'),
        });
      }
    }
  }, [props.policyInfo, get(props.claimRecap, 'claim.claimNumber')]);

  useEffect(() => {
    if (!isEmpty(get(props.policyInfo, 'sagis', {}))) {
      if (isLockedClaim(props.policyInfo)) {
        toast.error(
          translate({ ...messages.errorLockedClaim }, props, {
            username: get(
              resolveSagisClaim(props.policyInfo),
              'lockedBy',
              null,
            ),
          }) as string,
        );
        routesHelper.pushTo(
          `${PAGES.CONSULATION_OPENING_PAGE}/${get(props, [
            'match',
            'params',
            'claimId',
          ])}`,
        )();
      } else if (
        isBlockStatusClaim(props.policyInfo) &&
        get(props, 'claimRecap.claim.status') === STATUS_VALIDATED
      ) {
        props.resetStoreClaim();
        props.resetSearchClaimsStore();
        routesHelper.pushTo(
          `${PAGES.CONSULATION_OPENING_PAGE}/${get(props, [
            'match',
            'params',
            'claimId',
          ])}`,
        )();
      }
    }
  }, [props.policyInfo]);
  useEffect(() => {
    props.resetSearchClaimsStore();
    props.resetStoreClaim();
    setDataClaimToUpdate({});
    setIsFistUpdate(true);
    props.requestClaimRecap(props.match.params.claimId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.match.params.claimId]);

  useEffect(() => {
    props.resetSearchClaimsStore();
    if (!isEmpty(props.claimRecap)) {
      const searchQuery = renderSearchQuery(props.claimRecap);
      props.requestSearchClaims(searchQuery);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [get(props.claimRecap, 'claim.policyNumber', null)]);
  useEffect(() => {
    if (
      !isNil(get(props.claimRecap, 'claim.claimNumber', null)) &&
      get(props.claimRecap, 'claim.status') === STATUS_VALIDATED &&
      featureService.hasFeature(FEATURES.NEW_CLAIM_RECAP_GO)
    ) {
      props.requestSagisClaimInfo(
        get(props.claimRecap, 'claim.claimNumber', null),
      );
      props.requestGetRegulations(get(props.claimRecap, 'claim.id'));
      if (
        featureService.hasFeature(FEATURES.TRACKING_ACTIONS_USER) &&
        get(props.claimRecap, 'claim.status') === STATUS_VALIDATED
      ) {
        props.requestGetClaimHistoryActions(get(props.claimRecap, 'claim.id'));
        props.requestGetClaimHistorySagis(
          get(props.claimRecap, 'claim.claimNumber'),
        );
      }
    }
  }, [get(props.claimRecap, 'claim.claimNumber', null)]);
  useEffect(() => {
    if (!isEmpty(props.claimRecap) && isFistUpdate) {
      setDataClaimToUpdate(props.claimRecap);
      setIsFistUpdate(false);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.claimRecap]);

  const renderContentByStatus = () => {
    if (
      get(props.claimRecap, 'claim.status') === CLAIM_STATUS.PENDING ||
      get(props.claimRecap, 'claim.status') === CLAIM_STATUS.PENDING_APPROVAL ||
      get(props.claimRecap, 'claim.status') ===
        CLAIM_STATUS.PENDING_INFO_MODIFICATION
    ) {
      return (
        <PendingOrRejectedRecapClaim
          {...props}
          dataClaimToUpdate={dataClaimToUpdate}
          setDataClaimToUpdate={setDataClaimToUpdate}
          openFeeNoteDialog={openFeeNoteDialog}
          setOpenFeeNoteDialog={setOpenFeeNoteDialog}
        />
      );
    } else if (
      get(props.claimRecap, 'claim.status') === CLAIM_STATUS.VALIDATED &&
      featureService.hasFeature(FEATURES.NEW_CLAIM_RECAP_GO)
    ) {
      return (
        <ValidatedRecapClaim
          {...props}
          dataClaimToUpdate={dataClaimToUpdate}
          setDataClaimToUpdate={setDataClaimToUpdate}
          sagisClaim={props.sagisClaim}
          requestSagisClaimInfo={props.requestSagisClaimInfo}
          resetStoreClaim={props.resetStoreClaim}
          requestSetStatusClaimSagis={props.requestSetStatusClaimSagis}
          userActions={props.userActions}
          claimHistorySagis={props.claimHistorySagis}
          regulations={props.regulations}
          requestCreateFeeNoteManager={props.requestCreateFeeNoteManager}
          openFeeNoteDialog={openFeeNoteDialog}
          setOpenFeeNoteDialog={setOpenFeeNoteDialog}
          requestUploadDocumentManager={props.requestUploadDocumentManager}
        />
      );
    } else if (
      get(props.claimRecap, 'claim.status') === CLAIM_STATUS.REJECTED
    ) {
      return (
        <PendingOrRejectedRecapClaim
          {...props}
          dataClaimToUpdate={dataClaimToUpdate}
          setDataClaimToUpdate={setDataClaimToUpdate}
          openFeeNoteDialog={openFeeNoteDialog}
          setOpenFeeNoteDialog={setOpenFeeNoteDialog}
        />
      );
    } else {
      return (
        <PendingOrRejectedRecapClaim
          {...props}
          dataClaimToUpdate={dataClaimToUpdate}
          setDataClaimToUpdate={setDataClaimToUpdate}
          openFeeNoteDialog={openFeeNoteDialog}
          setOpenFeeNoteDialog={setOpenFeeNoteDialog}
        />
      );
    }
  };

  return <> {renderContentByStatus()}</>;
};

const mapDispatchToProps = {
  requestClaimRecap,
  requestSearchClaims,
  resetSearchClaimsStore,
  setClaimRecap,
  requestRejectClaim,
  requestOpenClaim,
  requestAssigment,
  requestCorporealLawyers,
  requestOpenMixedClaim,
  requestUpdateVictimInfo,
  requestValidateVictim,
  requestValidateVehicle,
  requestAddVictims,
  requestUpdateVehicleInfo,
  requestUpdateClaim,
  resetUploadDocumentStore,
  uploadDocument,
  setDocumentId,
  requestAddDocumentClaim,
  requestValidateProvisionIntervenant,
  requestLockClaim,
  requestUnlockClaim,
  setLockedClaim,
  resetStoreClaim,
  requestAddClaimNumber,
  requestGetFeeNotesByClaimId,
  requestAddInvoiceFeeNote,
  makeDecisionFeeNote,
  requestFeeNoteExceptionalCosts,
  requestFeeNotesByClaimNumb,
  requestAllFeeNotes,
  requestUpdateFeeNoteAmount,
  requestCreateFeeNote,
  requestUpdateFeeNoteStatus,
  requestUpdateInvoiceFeeNote,
  requestSagisClaimInfo,
  requestSetStatusClaimSagis,
  requestGetClaimHistoryActions,
  requestGetClaimHistorySagis,
  setCurrentInstanceTab,
  requestCreateStakeHolder,
  requestGetRegulations,
  requestCreateFeeNoteManager,
  requestResetHistoryStore,
  requestSetPriorityClaimProvision,
  requestGetReportsPolicy,
  requestMakeDecisionsDocumentImaging,
  requestGetPendingTasksClaim,
  requestGetNotificationsInboxes,
  requestUploadDocumentManager,
  requestGetDocByDocumentumId,
  requestUpdateFirmReferenceManager,
  requestValidateCompletionClaimManager,
};

const mapStateToProps = createStructuredSelector({
  listings: makeSelectListings(),
  claimRecap: makeSelecClaimRecap(),
  policyInfo: makeSelectSearchClaims(),
  corporealLawyers: makeSelectCorporealLawyers(),
  openedClaim: makeSelecOpenedClaim(),
  uploadedDocument: makeSelectDocument(),
  documentId: makeSelectDocumentId(),
  foundClaims: makeSelectFoundClaims(),
  feeNotes: makeSelectFeeNotes(),
  loaders: selectedLoader,
  allFeeNote: makeSelectAllFeeNotes(),
  feeNotesCount: makeSelectCountFeeNotes(),
  linkToBeneficiaryCodes: makeSelectLinkToBeneficiaryCodes(),
  sagisClaim: makeSelectSagisClaim(),
  userActions: makeSelectClaimHistoryActions(),
  claimHistorySagis: makeSelectClaimHistorySagis(),
  regulations: makeRegulations(),
  pendingTasksClaim: makeSelectPendingTasksClaim(),
  imagineNotification: makeSelectNotification(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(RecapManagerPage));
